// import { useForm } from "react-hook-form";
// import { useContext, useState } from "react";
// import "./LoginPage.css";
// import { UserContext } from "../../services/contexts/UserContext";
// import { ExecutePostWithParamsWithErrMsg } from "../../services/api/ExecuteApiRequests";
// import ForgotPassword from "./ForgotPassword"; //import DeviceInfo from "../../utils/DeviceInfo";

// const LoginUI = () => {
//   const { login } = useContext(UserContext);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);// *** State added here 
//   const [isLoggingIn, setIsLoggingIn] = useState(false);
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();

//   const [error, setError] = useState("");

//   const handleLogin1 = async data => {
//     try {
//       if (!data) return;
//       const newData = { username: data.username, password: data.password };
//       const resData = await ExecutePostWithParamsWithErrMsg("users/login", newData, false, setError); //      console.log(resData);
//       //alert("[login page]",error);
//       if (resData) {
//         const { accessToken } = resData; //console.log("token: ", accessToken);//console.log("user: ", user);
//         localStorage.setItem("token", accessToken);
//         login(accessToken);
//         setError("");
//       }
//     } catch (err) {
//       console.log(err);
//       console.log("Error from api", error);
//       setError(
//         err?.response?.message ||
//           error ||
//           "Credential not accepted, Please use correct username, password or device and try again.",
//       );
//     }
//   };

//   return (
//     <>
//       <div className="login-container">
//         <div className="ipdc-logo"></div>
//         <div className="login-left">
//           <div className="login-left-picture"></div>
//         </div>
//         <div className="login-right">
//           <form onSubmit={handleSubmit(handleLogin1)}>
//             <div className="login-title-header">Login</div>
//             <div className="title-line">
//               <hr />
//             </div>
//             <div>
//       <input
//                 type="text"
//                 placeholder="Username"
//                 className="username-input"
//                 {...register("username", { required: "Please enter username." })}
//                 autoComplete="username"
//                 autoCapitalize="off"
//                 autoCorrect="off"
//                 spellCheck="false"
//               />
//               <p className="error">{errors.username?.message}</p>
//             </div>
//             <div style={{ position: 'relative' }}> {/* change on position */}
//               <input
               
//                 type={showPassword ? "text" : "password"}
//                 placeholder="Password"
//                 className="username-input password-input"
//                 {...register("password", { required: "Password is required" })}
//                 autoComplete="current-password"
//               />
//               <button
//                   type="button"
//                   className="password-toggle"
//                   onClick={() => setShowPassword(!showPassword)}
//                   disabled={isLoggingIn}
//                   title={showPassword ? "Hide password" : "Show password"}
//                   style={{
//                     position: 'absolute',
//                     right: '10px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     background: 'transparent',
//                     border: 'none',
//                     outline: 'none',
//                     cursor: 'pointer',
//                     padding: '0',
//                     fontSize: '18px',
//                     color: '#666',
//                     lineHeight: '1'
//                   }}
//                 >
//                   {showPassword ? '👁️' : '👁️‍🗨️'}
//                 </button>
//                               <p className="error">{errors.password?.message}</p>
//             </div>
//             <div className="forget-password">
//               <a href="#" onClick={() => setShowForgotPassword(true)}>
//                 Forgot Password?{" "}
//               </a>
//               {showForgotPassword && <ForgotPassword onClose={e => setShowForgotPassword(true)} />}
//             </div>
//             <div>
//               <button type="submit" className="login-button">
//                 LOGIN
//               </button>
//             </div>

            
//             <div>{error && <p className="error">{error}</p>}</div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LoginUI;


import { useForm } from "react-hook-form";
import { useContext, useState } from "react";
import "./LoginPage.css";
import { UserContext } from "../../services/contexts/UserContext";
import { ExecutePostWithParamsWithErrMsg } from "../../services/api/ExecuteApiRequests";
import ForgotPassword from "./ForgotPassword";

const LoginUI = () => {
  const { login } = useContext(UserContext);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [error, setError] = useState("");

  const handleLogin1 = async data => {
    try {
      if (!data) return;
      const newData = { username: data.username, password: data.password };
      const resData = await ExecutePostWithParamsWithErrMsg("users/login", newData, false, setError);
      
      if (resData) {
        const { accessToken } = resData;
        localStorage.setItem("token", accessToken);
        login(accessToken);
        setError("");
      }
    } catch (err) {
      console.log(err);
      setError(
        err?.response?.message ||
          error ||
          "Credential not accepted, Please use correct username, password or device and try again.",
      );
    }
  };

  return (
    <>
      <div className="login-container">
        <div className="ipdc-logo"></div>
        <div className="login-left">
          <div className="login-left-picture"></div>
        </div>
        <div className="login-right">
          <form onSubmit={handleSubmit(handleLogin1)}>
            <div className="login-title-header">Login</div>
            <div className="title-line">
              <hr />
            </div>
            <div>
              <input
                type="text"
                placeholder="Username"
                className="username-input"
                {...register("username", { required: "Please enter username." })}
                autoComplete="username"
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
              <p className="error">{errors.username?.message}</p>
            </div>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="username-input password-input"
                {...register("password", { required: "Password is required" })}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoggingIn}
                title={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  cursor: 'pointer',
                  padding: '0',
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '1'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
              <p className="error">{errors.password?.message}</p>
            </div>
            <div className="forget-password">
              <a href="#" onClick={(e) => {
                e.preventDefault();
                setShowForgotPassword(true);
              }}>
                Forgot Password?{" "}
              </a>
              {/* ✅ FIXED: Set to false when closing */}
              {showForgotPassword && <ForgotPassword onClose={() => setShowForgotPassword(false)} />}
            </div>
            <div>
              <button type="submit" className="login-button">
                LOGIN
              </button>
            </div>
            <div>{error && <p className="error">{error}</p>}</div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginUI;